import { configTypes } from '@/models/featureConfig'

export const transformValue = ({ value, type }) => {
  switch (type) {
    case configTypes.INTEGER:
      return Number(value)

    case configTypes.BOOLEAN:
      return value === 'true'

    case configTypes.LIST:
      return value.split(' ').join('').split(',')

    default:
      return value
  }
}
